import { render, staticRenderFns } from "./ActivitiesTable.vue?vue&type=template&id=609422d6&scoped=true&"
import script from "./ActivitiesTable.vue?vue&type=script&lang=js&"
export * from "./ActivitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609422d6",
  null
  
)

export default component.exports